/** Google Cloud's logo URL. Kept separate from `gcloud`'s registration so the
 * MCP server specs can use it without registering the integration. */
export const GcloudIconUrl =
  "https://lh3.googleusercontent.com/VEnnK2SyklusfxZ3dIYjlQH3xSwK2BFSJ69TFQ9g8HjM6m3CouRlTia5FW3z3GS0x83WC9TylZCaA9Jf_2kmr7mXxI9_HYLZTFy_bg";
